import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconTypeScript = ({
  title = "TypeScript",
  color = "white",
  viewBoxWidth = 40,
  viewBoxHeight = 40,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g
      id="TypeScript"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon
        fill="#007ACC"
        fillRule="nonzero"
        transform="translate(20.000000, 20.000000) scale(-1, 1) rotate(-180.000000) translate(-20.000000, -20.000000) "
        points="0 20 0 0 20 0 40 0 40 20 40 40 20 40 0 40"
      />
      <path
        d="M22.9153333,34.9120097 L22.9280316,33.2739146 L20.3248571,33.2739146 L17.7216826,33.2739146 L17.7216826,25.8770891 L17.7216826,18.4802638 L15.8804127,18.4802638 L14.0391428,18.4802638 L14.0391428,25.8770891 L14.0391428,33.2739146 L11.4359682,33.2739146 L8.83279359,33.2739146 L8.83279359,34.8802638 C8.83279359,35.7691525 8.85184122,36.5120097 8.87723805,36.5310574 C8.89628567,36.5564542 12.0645396,36.5691525 15.9058094,36.5628035 L22.8962857,36.5437558 L22.9153333,34.9120097 Z"
        fill={uiColorToBaseColor(color)}
        fillRule="nonzero"
        transform="translate(15.880413, 27.522343) rotate(-180.000000) translate(-15.880413, -27.522343) "
      />
      <path
        d="M32.2760361,36.6050225 C33.2919092,36.3510542 34.0665123,35.9002605 34.7776234,35.1637526 C35.1458775,34.7701019 35.6919092,34.0526416 35.7363536,33.881213 C35.749052,33.8304192 34.0093695,32.6621653 32.9554012,32.008197 C32.9173059,31.9828001 32.764925,32.1478795 32.5934964,32.4018478 C32.0792108,33.1510542 31.5395283,33.4748637 30.7141314,33.5320066 C29.501433,33.6145462 28.7204806,32.9796256 28.7268298,31.9193081 C28.7268298,31.608197 28.7712742,31.42407 28.8982584,31.1701019 C29.164925,30.6177208 29.6601631,30.2875622 31.2157187,29.6145462 C34.0792108,28.3828001 35.3046077,27.5701019 36.0665123,26.4145462 C36.9173059,25.1256573 37.1077822,23.0685145 36.5300044,21.5383558 C35.8950837,19.8748637 34.3204806,18.744705 32.1046077,18.3701019 C31.4188933,18.2494669 29.7934964,18.2685145 29.0569886,18.4018478 C27.4506394,18.6875622 25.9268298,19.481213 24.9871473,20.5224828 C24.6188933,20.928832 23.901433,21.9891494 23.9458775,22.0653398 C23.964925,22.0907367 24.1300044,22.1923241 24.3141314,22.3002605 C24.4919092,22.4018478 25.164925,22.7891494 25.7998456,23.1574034 L26.949052,23.82407 L27.1903219,23.4685145 C27.5268298,22.9542287 28.2633378,22.2494669 28.7077822,22.0145462 C29.9839727,21.3415303 31.7363536,21.4367684 32.5998456,22.2113717 C32.9680997,22.5478795 33.1204806,22.8970859 33.1204806,23.4113717 C33.1204806,23.8748637 33.0633378,24.0780383 32.822068,24.4272447 C32.5109567,24.8716891 31.8760361,25.2462923 30.0728616,26.0272447 C28.0093695,26.9161336 27.1204806,27.4685145 26.3077822,28.344705 C25.8379409,28.8526416 25.3934964,29.6653398 25.2093695,30.344705 C25.0569886,30.9097844 25.0188933,32.3256573 25.1395283,32.8970859 C25.564925,34.8907367 27.0696869,36.281213 29.2411155,36.6939114 C29.9458775,36.8272447 31.5839727,36.7764509 32.2760361,36.6050225 Z"
        fill={uiColorToBaseColor(color)}
        fillRule="nonzero"
        transform="translate(30.402892, 27.529725) scale(-1, 1) rotate(-180.000000) translate(-30.402892, -27.529725) "
      />
    </g>
  </Svg.Icon>
)

export default IconTypeScript
